import { ref } from 'vue';
import { Group } from '@/entities/group';

export const useGroupRecord = () => ref<Group>({
  title: '',
  users: [],
});
